import { useStaticQuery, graphql } from 'gatsby';

const useMainMenu = () => {
  let menu = [];

  const { allPaperformHelpMainMenu } = useStaticQuery(
    graphql`
      query MainMenusQuery {
        allPaperformHelpMainMenu {
          edges {
            node {
              product {
                title
                link_url
                sub_menu {
                  title
                  description
                  link_url
                }
                featured_item {
                  title
                  description
                  image
                  link {
                    link_text
                    link_url
                  }
                }
              }
              solutions {
                title
                link_url
                sub_menu {
                  title
                  link_url
                  description
                }
                featured_item {
                  title
                  description
                  image
                  link {
                    link_url
                    link_text
                  }
                }
              }
              integrations {
                featured_item {
                  description
                  image
                  link {
                    link_url
                    link_text
                  }
                  title
                }
                integrations {
                  image
                  link_url
                  title
                }
                link_url
                title
              }
              templates {
                title
                link_url
                sub_menu {
                  title
                  link_url
                  description
                }
                featured_item {
                  title
                  description
                  image
                  link {
                    link_text
                    link_url
                  }
                }
              }
              resources {
                title
                link_url
                sub_menu {
                  title
                  link_url
                  description
                }
                help_menu {
                  title
                  link_url
                  description
                }
              }
              pricing {
                featured_item {
                  description
                  image
                  link {
                    link_text
                    link_url
                  }
                  title
                }
                link_url
                sub_menu {
                  description
                  link_url
                  title
                }
                title
              }
            }
          }
        }
      }
    `,
  );

  const data = allPaperformHelpMainMenu?.edges[0]?.node;

  return data ? { menuItems: Object.values(data) } : menu;
};

export default useMainMenu;
